import {default as Base} from "../base/Main";
import Products from "./Components/Products";
import Initializer from "./Components/Blocks/Initializer";

export default class Main extends Base {

	public init(): void {
		super.init();

		new Products();
	}

	initializeBlocks() {
		return new Initializer();
	}
}
